// extracted by mini-css-extract-plugin
export var buttonContent = "_3b-0";
export var centered = "_3b-1";
export var centeredFlex = "_3b-2";
export var errorText = "_3b-3";
export var icon = "_3b-4";
export var iconButtonContent = "_3b-5";
export var monospace = "_3b-6";
export var padded = "_3b-7";